import React, { Component, Fragment } from 'react'
import PropTypes from "prop-types"
import Autocomplete from '../autocomplete';
import moment from 'moment';
import request from "../../lib/requester";

class ClaimInfo extends Component {
  static propTypes = {
    data: PropTypes.object
  }
  
  static defaultProps = {
    data: {}
  }

  constructor(props) {
    super(props);
    this.state = {}
  }

  renderLovPPh = () => {
    return (
      <select disabled className="form-control" name="pphType" value={this.props.data.pphType} >
        <option>- Select Type -</option>
        {this.props.data.lovPPH.map((item, index) => (
          <option value={item.pph_type} key={index}>
            {item.pph_type}
          </option>
        ))}
      </select>
    );
  };

  removeSeparator = (value) => {
    value = value.toString();
    return value.replace(/,/g, "");
  };

  thousandSeparator = (value) => {
    if (!value) return
    
    value = value.toString();
    value = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  renderTableInvoice = () => {
    if (this.props.data.paymentMethod === "INV") {
      return (
        <table className="table table-striped table-sm table-bordered">
          <thead>
            <tr>
              <th>Invoice Number</th>
              <th>Invoice Amount</th>
              <th>Invoice Date</th>
            </tr>
          </thead>
          <tbody>
            {this.props.data.listInvoice.map((item, index) => (
              <tr key="index">
                <td>{item.invoice_number}</td>
                <td className="text-right">
                  {this.thousandSeparator(item.invoice_amount)}
                </td>
                <td>
                  {moment(new Date(item.invoice_date)).format("DD-MMM-YYYY")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }
  };

  onChangeAutocomplete = (q) => {
    let param = {
      supplier_name: q,
    };
    return new Promise((resolve, reject) => {
      request.postOracle("/api/orafin/v1/claim/list-supplier", param, {
        success: function (response) {
          let { data } = response.data;
          let lovSupplier = [];
          data.forEach((item, index) => {
            // [0] supplier name [1] supplier id
            lovSupplier.push({ text: item[0], value: item[1] });
          });
          resolve(lovSupplier);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  };

  onSelectSupplier = (item, index) => {
    this.setState({ supplier: item.text, supplierId: item.value });
    this.getSupplierSite(item.value);
  };

  renderNorek = () => {
    if (this.props.data.paymentMethod === "TRF") {
      // if (this.props.data.orgInitial === 'AAM') {
      if (1 === 1) {
        return (
          <div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-4 col-form-label"> Supplier </label>
              <div className="col-sm-8">
                <Autocomplete onchange={this.onChangeAutocomplete.bind(this)} isDisabled={true} currentvalue={this.props.data.supplier} currentIndex={0} principalCode={this.props.data.user.orgInitial} onselect={this.onSelectSupplier.bind(this)} />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Supplier Site</label>
              <div className="col-sm-8">
                <select className="form-control" disabled value={this.props.data.supplierSite} name="supplierSite" >
                  <option value="">- Select Supplier Site -</option>
                  {this.props.data.lovSupplierSite.map((item, index) => (
                    <option value={item.SUPPLIER_SITE_ID}>
                      {item.SUPPLIER_SITE_CODE}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Account No</label>
              <div className="col-sm-8">
                <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" name="norek" placeholder="No Rekening" value={this.props.data.norek} />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-4 col-form-label"> Bank Name</label>
              <div className="col-sm-8">
                <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" name="bankName" placeholder="No Rekening" value={this.props.data.bankName} />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Account Owner</label>
              <div className="col-sm-8">
                <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" name="accOwner" placeholder="No Rekening" value={this.props.data.accOwner} />
              </div>
            </div>
          </div>
        );
      }
    }
  };
  
  renderTax = () => {
    let { ppn } = this.props.data;
    if (parseInt(this.removeSeparator(ppn)) > 0) {
      return (
        <div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Tax No</label>
            <div className="col-sm-8">
              <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" name="taxNo" placeholder="Tax No" value={this.props.data.taxNo} />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Tax Date
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                disabled
                className="form-control"
                value={this.props.data.taxDate}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  handleRedirect = (e) => {
    e.preventDefault()
    const url = request.getFileS3('skb', this.props.data.fileSKB.filename);
    if (url && url.length > 0) {
      window.open(url, '_blank');
    }
  };

  renderSKBAttachment = () => {
    if (this.props.data.skb === "Y") {
      return (
        // <a href={this.props.data.fileSKB.path} target="_blank" rel="noopener noreferrer" >{this.props.data.fileSKB.filename}</a>
        <a
              href="#"
              onClick={this.handleRedirect.bind(this)}
              target="blank"
              rel="noopener noreferrer"
            >
              {this.props.data.fileSKB.filename}
            </a>
      );
    }
  };

  render() {
    return (
      <Fragment>
        <div className="card">
          <div className="card-header bg-light font-weight-bold">Claim Info</div>
          <div className="multi-collapse show" id="multiCollapseExample1">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label" >Payment Method</label>
                    <div className="col-sm-8 mt-2">
                      <div className="form-check form-check-inline">
                        <input disabled className="form-check-input" type="radio" checked={ this.props.data.paymentMethod === "INV" ? true : false } name="potongTagihan" id="inlineRadio1" value="INV" />
                        <label className="form-check-label" htmlFor="inlineRadio1" > Deduct to receivable </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input disabled className="form-check-input" type="radio" checked={ this.props.data.paymentMethod === "TRF" ? true : false } name="potongTagihan" id="inlineRadio2" value="TRF" />
                        <label className="form-check-label" htmlFor="inlineRadio2" > Transfer </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input disabled className="form-check-input" type="radio" checked={ this.props.data.paymentMethod === "DEP" ? true : false } name="potongTagihan" id="inlineRadio2" value="DEP" />
                        <label className="form-check-label" htmlFor="inlineRadio2" > Deposit </label>
                      </div>
                    </div>
                  </div>
                  {this.renderNorek()}
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label" > NPWP / NIK </label>
                    <div className="col-sm-8">
                      <input type="text" disabled autoComplete="off" className="form-control" id="inputEmail3" name="npwp" placeholder="NPWP" value={this.props.data.npwp} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label"> Customer PPh Type </label>
                    <div className="col-sm-8">{this.renderLovPPh()}</div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Rate <small>(%)</small></label>
                    <div className="col-sm-3">
                      <input disabled type="number" autoComplete="off" max="100" min="0" className="form-control" id="inputEmail3" name="pphRate" placeholder="" value={this.props.data.pphRate} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">DPP</label>
                    <div className="col-sm-8">
                      <input disabled type="text" autoComplete="off" className="form-control" id="inputEmail3" name="dpp" placeholder="" value={this.props.data.dpp} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">PPN</label>
                    <div className="col-sm-8">
                      <input disabled type="text" autoComplete="off" className="form-control" id="inputEmail3" name="ppn" placeholder="" value={this.props.data.ppn} />
                    </div>
                  </div>
                  {this.renderTax()}
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">SKB</label>
                    <div className="col-sm-1 mt-2">
                      <div className="form-check form-check-inline">
                        <input className="form-check-input" disabled type="checkbox" checked={ this.props.data.skb === "Y" ? true : false } name="skb" id="inlineRadio1" value="Y" />
                      </div>
                    </div>
                    {this.renderSKBAttachment()}
                  </div>
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">PPh</label>
                    <div className="col-sm-8">
                      <input disabled type="text" autoComplete="off" className="form-control" id="inputEmail3" name="pph" placeholder="" value={this.props.data.pph} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Total Claim</label>
                    <div className="col-sm-8">
                      <input disabled type="text" autoComplete="off" className="form-control" id="inputEmail3" name="totalAmount" placeholder="" value={this.props.data.totalAmount} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Customer Receipt No.</label>
                    <div className="col-sm-8">
                      <input disabled type="text" autoComplete="off" className="form-control" id="inputEmail3" name="totalAmount" placeholder="" value={this.props.data.cust_receipt_no} />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  {this.renderTableInvoice()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default ClaimInfo